module.exports = __webpack_public_path__ + "static/img/KE.5dd0a4fc.svg";